/**
 * Field names whose values must never reach a log line or an error message:
 * the logger censors them in structured fields, and `toError` / `wrapError`
 * censor them when they have to serialise an object into message text.
 */
export const SENSITIVE_KEYS = new Set([
    'password',
    'token',
    'sessionToken',
    'accessToken',
    'refreshToken',
    'idToken',
    'authorization',
    'cookie',
    'apiKey',
    'api_key',
    'secret',
    'clientSecret',
    'privateKey',
    'encryptionKey',
    'connectionString',
    'DATABASE_URL',
]);
export const CENSOR = '[REDACTED]';
//# sourceMappingURL=sensitive-keys.js.map